function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 -0.5 17 17",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    transform: "translate(-0.5,0.522) matrix(0.03375648,0,0,0.03375648,0.50000019,-1.0219996)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 503.607,
    height: 157.377,
    x: -503.607,
    y: 173.67,
    ry: 0,
    style: {
      fill: "#000000",
      strokeWidth: 0.629509
    },
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.377 472.132H346.23v31.475H157.377Z",
    style: {
      fill: "#000000",
      strokeWidth: 0.582812
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03375648,0,0,0.03375648,0.01873485,-1.2033498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.555 193.951H173.82v157.377H-.555Z",
    style: {
      fill: "#808080",
      strokeWidth: 0.629509
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.418 193.951 157.326 72.975-157.048 84.073",
    style: {
      fill: "#808080",
      strokeWidth: 0.629509
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTee);
export default __webpack_public_path__ + "static/media/tee.370729d32f3ff2c3008307e87ac18f3a.svg";
export { ForwardRef as ReactComponent };